module.exports = __webpack_public_path__ + "img/current_off.ce1cbfc5.png";